import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import NotificationSettings from './model';

export const fetchNotificationSettings = () => {
    return RESTClient.getAuthenticatedObservable('v2/notificationsettings').map(settings =>
        List(settings).map(NotificationSettings.fromAPI),
    );
};

export const updateNotificationSettings = notificationSettings => {
    return RESTClient.postAuthenticatedObservable('v2/notificationsettings', {notificationSettings}).map(settings =>
        List(settings).map(NotificationSettings.fromAPI),
    );
};
